enum DirectionEnum {
  DESCENDING = 'DESC',
  ASCENDING = 'ASC',
  DEFAULT = 'DEFAULT',
}

export default DirectionEnum;
